import React from 'react';

export const WishlistToggle = () => {
    return null;
};
